import { WebsiteBlock } from "../interfaces/WebsiteBlock";

export function createDefaultNavbarBlock(brandName = "Mi Marca"): WebsiteBlock {
  const brand = String(brandName || "Mi Marca").trim() || "Mi Marca";
  return {
    id: "navbar-1",
    type: "navbar",
    brandName: brand,
    logoInitial: brand.charAt(0).toUpperCase(),
    links: [
      { label: "Inicio", href: "#inicio" },
      { label: "Servicios", href: "#servicios" },
      { label: "Contacto", href: "#contacto" },
    ],
    ctaLabel: "Comenzar",
    ctaHref: "#contacto",
    backgroundColor: "#ffffff",
    menuBackgroundColor: "#ffffff",
    textColor: "#0f172a",
    accentColor: "#4f46e5",
    sticky: true,
  };
}

export function ensureNavbarBlocks(blocks: WebsiteBlock[] = [], brandName = "Mi Marca"): WebsiteBlock[] {
  if (blocks.some((block) => block.type === "navbar")) return blocks;
  return [createDefaultNavbarBlock(brandName), ...blocks];
}
